import React, { useEffect, useMemo } from "react";
import { ColDef, GetRowIdParams } from "ag-grid-community";
import { useDispatch, useSelector } from "react-redux";

import { NlisHoldingsAction } from "actions/nlisHoldings";

import AgGridContainer from "components/AgGrid/AgGridContainer";
import LoadingSpinner from "components/LoadingSpinner";
import MessageBox from "components/MessageBox";

import { AgGridTables } from "constants/aggrid";
import {
  NlisHoldingsColumnDefinitions,
  type NlisHoldingDeviceRow,
} from "constants/columnDefinitions/nlisHoldings";

import {
  selectNlisHoldingDeviceRows,
  getIsFetchingNlisHoldings,
} from "selectors";

const getRowId = ({ data }: GetRowIdParams<NlisHoldingDeviceRow>): string =>
  `${data.holding.id}-${data.device.id}`;

export function NLISHoldings(): React.JSX.Element {
  const dispatch = useDispatch();
  const rows = useSelector(selectNlisHoldingDeviceRows);
  const isFetching = useSelector(getIsFetchingNlisHoldings);

  useEffect(() => {
    dispatch(NlisHoldingsAction.request());
  }, [dispatch]);

  const columns = useMemo<ColDef<NlisHoldingDeviceRow>[]>(
    () => Object.values(NlisHoldingsColumnDefinitions),
    [],
  );

  if (isFetching && rows.length === 0) {
    return (
      <MessageBox>
        <LoadingSpinner subjectName="NLIS Holdings" size={24} />
      </MessageBox>
    );
  }

  return (
    <AgGridContainer
      rowData={rows}
      columnDefs={columns}
      tableName={AgGridTables.NLIS_HOLDINGS}
      getRowId={getRowId}
      showTextFilter
    />
  );
}
